import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';

import {CoreModule} from './modules/core/core.module';
import {SharedModule} from './modules/shared/shared.module';

import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions} from '@angular/material/form-field';

const appearance: MatFormFieldDefaultOptions = {
    appearance: 'fill'
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        SharedModule,
        CoreModule,
    ],
    providers: [
        // freeze floating label
        // {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}}

        //set default global style for forms
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearance}
        // {
        //     provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        //     useValue: {appearance: 'legacy'}
        // },
        // {
        //     provide: MAT_LABEL_GLOBAL_OPTIONS,
        //     useValue: {float: 'always'}
        // },
        // {
        //     provide: MAT_RIPPLE_GLOBAL_OPTIONS,
        //     useValue: {disabled: true}
        // },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
